import React from 'react'
import styled from 'styled-components'

import Theme from 'styles/theme'
import media from 'styles/media'

import Button from 'components/display/Button'
import ButtonLink from 'components/display/ButtonLink'
import LazyImage from 'components/display/LazyImage'
import UniformOverlay from 'components/display/Overlay/Uniform'

const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  z-index: 2;
  padding: 30px;
  padding-top: 80px;

  ${media.md`
    padding: 80px 80px 40px 80px;
  `}

  ${media.xl`
    padding: 100px;
    width: 60%;
  `}

  & > * {
    max-width: 720px;
  }

  & > * + * {
    margin-bottom: 20px;
  }

  h1 {
    font-size: ${({ theme }) =>
      theme?.['-ds-font-size-xl']?.['font-size']?.value};
    font-weight: ${({ theme }) =>
      theme?.['-ds-font-size-xl']?.['font-weight']?.value};
    line-height: 1.3;

    ${media.md`
      font-size: ${({ theme }) =>
        theme?.['-ds-font-size-xxxl']?.['font-size']?.value};
      font-weight: ${({ theme }) =>
        theme?.['-ds-font-size-xxxl']?.['font-weight']?.value};
      line-height: 1.2;
    `};
  }

  h2 {
    font-size: ${({ theme }) =>
      theme?.['-ds-font-size-xs']?.['font-size']?.value};
    font-weight: ${({ theme }) =>
      theme?.['-ds-font-size-xs']?.['font-weight']?.value};
    line-height: 1.4;

    ${media.md`
      font-size: ${({ theme }) =>
        theme?.['-ds-font-size-lg']?.['font-size']?.value};
      font-weight: ${({ theme }) =>
        theme?.['-ds-font-size-lg']?.['font-weight']?.value};
   `}
  }

  ${Button}, ${ButtonLink}, a {
    margin-top: 50px;

    ${media.md`
      width: fit-content;
    `}
  }
`

const HeaderInner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: stretch;
  position: relative;
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;

  color: white;

  ${media.xl`
    flex-direction: row;
  `}

  ${LazyImage} {
    position: absolute;
    object-position: bottom center;
  }

  h3 {
    z-index: 2;
    position: absolute;
    top: 20px;
    right: 20px;
    font-size: ${({ theme }) =>
      theme?.['-ds-font-size-xxl']?.['font-size']?.value};
    font-weight: ${({ theme }) =>
      theme?.['-ds-font-size-xxl']?.['font-weight']?.value};
    margin: 0;

    ${media.md`
      font-size: ${({ theme }) =>
        theme?.['-ds-font-size-xxxl']?.['font-size']?.value};
      font-weight: ${({ theme }) =>
        theme?.['-ds-font-size-xxxl']?.['font-weight']?.value};
    `};
  }
`

type HeaderProps = {
  h1Text?: React.ReactNode
  h2Text: React.ReactNode
  h3Text?: React.ReactNode
  cta?: React.ReactNode
  imageUrl?: string
}

const SmallHeader: React.FC<HeaderProps> = ({
  h1Text,
  h2Text,
  h3Text,
  cta,
  imageUrl,
}) => (
  <HeaderInner>
    <UniformOverlay color={Theme['-ds-core-300'].value} zIndex={1} />
    <LazyImage data-src={imageUrl} preload />
    <h3>{h3Text}</h3>
    <Content>
      <h1>{h1Text}</h1>
      <h2>{h2Text}</h2>
      {cta}
    </Content>
  </HeaderInner>
)

export default SmallHeader
